export default function (formLink, isValid, localValue, onChangeCallback) {
    return formLink
        ? formLink.bind(props.inputName, localValue.value, isValid.value)
        : onChangeCallback
}
